import { Heading } from '@slal/ui/typography';
import { DocumentLink } from '~/components';
import { useSelectedInvestmentPathway } from '~/hooks';
import { StyledFundFactsheetLoading, StyledInvestmentPathwaysFundFactsheet } from './styles';
import { InvestmentPathwayProps } from './types';

export const InvestmentPathwayFactsheet = ({ fundCode }: InvestmentPathwayProps) => {
    const { investmentPathway, loading } = useSelectedInvestmentPathway(fundCode);

    if (!loading && !investmentPathway) return null;

    if (!investmentPathway?.factsheetUrl) return null;

    const id = 'investment-pathway--factsheet';

    return (
        <StyledInvestmentPathwaysFundFactsheet aria-labelledby={id}>
            <Heading level={5} id={id}>
                Want to know more about this option?
            </Heading>

            {loading ? (
                <StyledFundFactsheetLoading />
            ) : (
                <DocumentLink href={investmentPathway.factsheetUrl!}>Fund factsheet</DocumentLink>
            )}
        </StyledInvestmentPathwaysFundFactsheet>
    );
};
